/**
 *
 * ForgotPassword
 *
 */

import SmallLogoFooter from '@gameday/common/components/form/Common/SmallLogoFooter'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from 'classnames/bind'
import React from 'react'
import { Link } from 'react-router-dom'

import * as validations from '../../helpers/validations'
import { CornerHexagonBg } from '../Background/CornerHexagons'
import { PrimaryButton } from '../Button'
import InputField from '../InputField'
import Paper from '../Paper'
import STGTermsAndConditions from '../STGTermsAndConditions'

const styles = theme => ({
  pageWrapper: {
    padding: '50px 30px 20px 30px',
    zIndex: 2,
    [theme.breakpoints.down(400)]: {
      padding: '30px 20px',
      background: '#fff !important',
    },
    '& .MuiPaper-root': {
      padding: '42px 34px',
      [theme.breakpoints.down(400)]: {
        padding: '30px 20px',
      },
    },
    '[data-theme="dark"] & .MuiPaper-root': {
      backgroundColor: theme.colors.darkModeLowBlack,
    },
    '&.fixed': {
      position: 'fixed',
    },
  },
  zeroMinHeight: {
    minHeight: 0,
  },
  form: {
    width: '100%', // Fix IE11 issue.
  },
  justifyCenter: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    margin: '0 auto 38px',
    maxWidth: 260,
    [theme.breakpoints.down(400)]: {
      margin: '0 auto 18px',
      maxWidth: 206,
    },
  },
  FormSubHeading: {
    color: `var(--gameday-body-headingColor, ${theme.body.headingColor})`,
    textAlign: 'center',
  },
  title: {
    fontSize: theme.typography.fontSizeMedish,
    fontWeight: theme.typography.fontWeightBolder,
    margin: '0 0 12px',
    color: theme.body.headingColor,
    '[data-theme="dark"] &': {
      color: theme.colors.darkModeOffWhite,
    },
    [theme.breakpoints.down(400)]: {
      fontSize: theme.typography.fontSizeBase,
      margin: '0 0 6px',
    },
  },
  intro: {
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-body-textColor, ${theme.body.textColor})`,
    textAlign: 'center',
    maxWidth: 250,
    margin: '0 0 25px',
    [theme.breakpoints.down(400)]: {
      margin: '0 0 22px',
    },
  },
  navLink: {
    paddingTop: 10,
    textAlign: 'center',
    '& a': {
      textDecoration: 'none',
      color: theme.palette.primary.main,
      fontSize: theme.typography.fontSizeSm,
      fontWeight: theme.typography.fontWeightBolder,
    },
  },
  textBox: {
    paddingBottom: '1rem',
    textAlign: 'center',
  },
  info: {
    color: theme.status.successColor,
  },
  error: {
    color: theme.status.errorColor,
  },
  success: {
    color: theme.status.successColor,
  },
  inputField: {
    marginBottom: 4,
    [theme.breakpoints.down(400)]: {
      marginBottom: -6,
    },
    '[data-theme="dark"] & .MuiInputBase-input': {
      backgroundColor: `${theme.colors.darkModeHighGrey} !important`,
      color: `${theme.colors.darkModeOffWhite} !important`,
    },
    '[data-theme="dark"] & .MuiInputBase-adornedStart, [data-theme="dark"] & .MuiInputBase-adornedEnd': {
      backgroundColor: `${theme.colors.darkModeHighGrey} !important`,
    },
  },
})
/* eslint-disable react/prefer-stateless-function */
class ForgotPasswordPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fields: {
        email: {
          value: '',
          isError: false,
          errorMessage: 'Please enter email.',
        },
      },
    }
  }

  componentWillReceiveProps(nextProps) {
    const { formError } = nextProps
    if (formError.length > 0) {
      const fields = this.clearFields()
      this.setState({
        fields,
      })
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    const { handleSubmit } = this.props
    const { fields } = this.state
    handleSubmit(fields)
  }

  clearFields = () => {
    const { fields } = this.state
    fields.email.value = ''
    fields.email.isError = true
    return fields
  }

  onChange = (value, name) => {
    const { fields } = this.state
    let isErr = false
    let errMsg = ''
    const temp = { ...fields }
    temp[name].value = value
    if (name === 'email') {
      errMsg = validations.validateEmail(value)
      if (errMsg) {
        isErr = true
      }

      if (value.length === 0) {
        isErr = false
      }
    }
    temp[name].isError = isErr
    temp[name].errorMessage = errMsg
    this.setState({
      fields: temp,
    })
  }

  render() {
    const {
      classes,
      title,
      redirectLoginPath,
      backgroundImage,
      formInfo,
      formSuccess,
      formError,
      loadingForgotPassword,
      showTermsAndConditions,
      logo,
      application,
      customWidth,
      isFixed,
      isAdminPortalVersion,
      primaryColor,
      secondaryColor,
      reversed,
    } = this.props
    const { fields } = this.state
    const { email } = fields

    return (
      <>
        <Paper
          application={application}
          style={{ height: '100%' }}
          width={customWidth}
          classes={{
            root: classNames(classes.pageWrapper, isFixed && 'fixed', !isAdminPortalVersion && classes.zeroMinHeight),
          }}
        >
          <div className={classNames(classes.justifyCenter)}>
            <img className={classNames(classes.logo)} src={logo} alt="logo" />
          </div>
          {formInfo.length > 0 ? <div className={classNames(classes.textBox, classes.info)}>{formInfo}</div> : ''}
          {formSuccess.length > 0 ? (
            <div className={classNames(classes.textBox, classes.success)}>{formSuccess}</div>
          ) : (
            ''
          )}
          {formError.length > 0 ? <div className={classNames(classes.textBox, classes.error)}>{formError}</div> : ''}
          <div className={classNames(classes.FormSubHeading)}>
            <h2 className={classes.title}>{title}</h2>
          </div>
          <div className={classes.intro}>Enter your email and we’ll send you a link to reset your password.</div>
          <form className={classes.form} onSubmit={this.handleSubmit}>
            <Grid container>
              <Grid item xs={12}>
                <InputField
                  className={classNames(classes.inputField)}
                  label="Email"
                  id="email-field"
                  isRequired
                  errorText={email.isError ? email.errorMessage : ''}
                  value={email.value}
                  onChange={event => this.onChange(event.target.value, 'email')}
                  name="email"
                  withBorder
                  dataTestId="forgotPasswordEmailField"
                />
              </Grid>
              <Grid item xs={12}>
                <PrimaryButton
                  fullWidth
                  disableRipple
                  type="submit"
                  id="submit-button"
                  disabled={email.value.length === 0 || email.isError}
                  data-testId="sendLinkButton"
                >
                  {loadingForgotPassword ? 'Processing...' : 'Send Reset Link'}
                </PrimaryButton>
              </Grid>
            </Grid>
          </form>
          <div className={classNames(classes.navLink)}>
            <Link to={`${redirectLoginPath}`}>Back to Login</Link>
          </div>
          {showTermsAndConditions && <STGTermsAndConditions />}
        </Paper>
        {isAdminPortalVersion ? null : <SmallLogoFooter />}
        {!backgroundImage && (
          <CornerHexagonBg useWindow primaryColor={primaryColor} secondaryColor={secondaryColor} reversed={reversed} />
        )}
      </>
    )
  }
}

ForgotPasswordPage.defaultProps = {
  formInfo: '',
  formSuccess: '',
  formError: '',
  application: '',
  reversed: false,
}

export default withStyles(styles)(ForgotPasswordPage)
